import { createReducer, on } from '@ngrx/store';
import { lessonsActions } from '../actions/lessons.actions';
import { Lesson } from '../models';
import { PaginationParams } from '../types';

export interface LessonsState {
    loaded: boolean | null;
    loading: boolean | null;
    lessons: Lesson[];
    total: number;
    page: number;
    limit: number;
    lastParams: PaginationParams;
}

export const initialState: LessonsState = {
    loaded: null,
    loading: null,
    lessons: [],
    total: 0,
    page: 1,
    limit: 20,
    lastParams: { page: 1, limit: 20 },
};

export const lessonsReducer = createReducer(
    initialState,
    on(lessonsActions.getLessons, (state, { value }): LessonsState => ({
        ...state,
        loading: true,
        page: value.page,
        limit: value.limit,
        lastParams: value,
    })),
    on(lessonsActions.getLessonsSuccess, (state, { payload, total }): LessonsState => ({
        ...state,
        loaded: true,
        loading: false,
        lessons: payload,
        total,
    })),
    on(lessonsActions.getLessonsError, (state): LessonsState => ({
        ...state,
        loaded: false,
        loading: false,
    })),
    on(lessonsActions.clear, (): LessonsState => ({ ...initialState })),
);
